import moment from 'moment';
import 'moment/dist/locale/es';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/it';
import 'moment/dist/locale/pt'; // European Portuguese

// Week starts on Monday for all locales (moment's 'en' default is Sunday)
moment.updateLocale('en', {
  week: {
    dow: 1, // Monday
  },
});

// override moment default locale for french
// so we don't have dots at the end of the day/month names
moment.updateLocale('fr', {
  weekdaysShort: 'dim_lun_mar_mer_jeu_ven_sam'.split('_'),
  monthsShort: 'janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc'.split(
    '_',
  ),
});

moment.updateLocale('fr', {
  relativeTime: {
    future: 'dans %s',
    past: 'il y a %s',
    s: 'quelques secondes',
    ss: '%d secondes',
    m: 'une minute',
    mm: '%d minutes',
    h: 'une heure',
    hh: '%d heures',
    d: 'un jour',
    dd: '%d jours',
    M: 'un mois',
    MM: '%d mois',
    y: 'un an',
    yy: '%d ans',
  },
});

// Registering a locale — the `fr` import above, every `updateLocale` call —
// switches moment's global locale as a side effect. Land back on moment's own
// default: the active locale is owned by `initI18n` (src/i18n.ts), and code
// formatting dates before it resolves must not silently get French.
moment.locale('en');
